'use strict';

frontendApp.directive('iioFilter', ['HttpService', 'ConfigService', 'NotificationService', function(HttpService, ConfigService, NotificationService) {

    return {
        require: 'ngModel',
        restrict:'E',
        template: '<div class="input-group filter" style="width:200px;">'
                   + '<span class="input-group-addon"><i class="fas fa-filter"></i></span>'
                   + '<input type="text" class="form-control" ng-model="inputVal" placeholder="Filter List" iio-input-notice />'
                   + '<span class="input-group-btn" ng-show="inputVal">'
                     + '<button class="btn btn-default" tooltip="Clear Filter" ng-click="clearFilter()">'
                       + '<i class="fas fa-times"></i>'
                     + '</button>'
                   + '</span>'
                + '</div>',
        scope: {
            inputVal: '=ngModel'
        },

        link: function(scope, element, attrs, ngModelCtrl) {
            scope.clearFilter = function() {
                scope.inputVal = '';
            };

        }
    }
}]);
